/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-03-08 19:53:42
 *
 *******************************************************/
//@flow

import _ from 'lodash';

import React, { Component } from 'react';
import { Card, Heading, SkeletonBodyText, Link } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { connect } from 'react-redux';
import { URL } from 'src/constants/links';
import * as dashboardV3Action from 'actions/dashboard-v3-actions';

type ComposedProps = Props & WithI18nProps;
class ChangeLogs extends Component<ComposedProps> {
  componentDidMount() {
    this.props.getChangeLogs();
  }
  render() {
    const { i18n, changeLogs, gettingChangeLogs } = this.props;
    const allChanges = _.get(changeLogs, 'changes', []);

    return (
      <div className="BC-ChangeLogs__Dashboard V4">
        <Card sectioned>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
            <Heading>{i18n.translate('AdminHTML.DashboardV3.LatestUpdate.title')}</Heading>
            <Link external url={URL['ChangeLogsV2']}>
              {i18n.translate('AdminHTML.DashboardV3.SyncHookStatus.actionLabel')}
            </Link>
          </div>
          {gettingChangeLogs ? (
            <div className="date">
              <SkeletonBodyText lines={5} />
            </div>
          ) : (
            <>
              <div>
                <p>
                  <b>{i18n.translate('AdminHTML.DashboardV3.LatestUpdate.label_new')}</b>
                </p>
                <ul>
                  {allChanges
                    .find(i => i.tag === 'new')
                    ?.lines.map((i, idx) => {
                      return <li key={idx}>{i}</li>;
                    })}
                </ul>
              </div>

              <div>
                <p>
                  <b>{i18n.translate('AdminHTML.DashboardV3.LatestUpdate.label_improve')}</b>
                </p>
                <ul>
                  {allChanges
                    .find(i => i.tag === 'improved')
                    ?.lines.map((i, idx) => {
                      return <li key={idx}>{i}</li>;
                    })}
                </ul>
              </div>
            </>
          )}
        </Card>
      </div>
    );
  }
}
const mapStateToProps = (state, props) => {
  return {
    changeLogs: _.get(state.dashboardV3, 'changeLogs', {}),
    gettingChangeLogs: _.get(state.dashboardV3, 'gettingChangeLogs', {})
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  getChangeLogs: () => dispatch(dashboardV3Action.getChangeLogs(ownProps.i18n))
});

export default connect(mapStateToProps, mapDispatchToProps)(withI18n()(ChangeLogs));
